import { render, staticRenderFns } from "./FindInitialFocalPoint.vue?vue&type=template&id=1ffaf5e1&scoped=true"
import script from "./FindInitialFocalPoint.vue?vue&type=script&lang=js"
export * from "./FindInitialFocalPoint.vue?vue&type=script&lang=js"
import style0 from "./FindInitialFocalPoint.vue?vue&type=style&index=0&id=1ffaf5e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffaf5e1",
  null
  
)

export default component.exports